import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeCustom } from '../traitTypes/TraitTypeCustom';
export class TraitRegistryBundle extends TraitRegistryCategory {
    label = 'Bundle';
    constructor(parent) {
        super(parent);
        super.init();
    }
    importbundle = new TraitTypeCustom({
        //  label: 'Importiere Bundle',
        multiple: true
        //   icon: 'fa fa-clone',
        //  aspectsTemplate: { core: ['preloadBundle'] }
    });
}
